module.exports = __webpack_public_path__ + "img/1.da4c167a.png";